module.exports = __webpack_public_path__ + "static/media/mobile-placeholder.610cb4de.png";